(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  (() => {
    const initialize = (scope) => {
      scope.querySelectorAll('[data-zuuska-footer]').forEach((footer) => {
        if (footer.hasAttribute('data-footer-ready')) return;
        const columns = Array.from(footer.querySelectorAll('[data-footer-column]'));
        const viewport = window.matchMedia('(max-width: 749px)');
        const synchronize = () => {
          const mobile = viewport.matches;
          if (footer.dataset.footerMobile === String(mobile)) return;
          footer.dataset.footerMobile = String(mobile);
          columns.forEach((column) => {
            const summary = column.querySelector('summary');
            column.open = !mobile;
            if (mobile) summary.removeAttribute('tabindex');
            else summary.setAttribute('tabindex', '-1');
          });
        };
        columns.forEach((column) => {
          column.querySelector('summary').addEventListener('click', (event) => {
            if (footer.dataset.footerMobile === 'false') event.preventDefault();
          });
        });
        footer.querySelectorAll('[data-footer-localization]').forEach((select) => {
          select.addEventListener('change', () => {
            if (!select.form) return;
            if (typeof select.form.requestSubmit === 'function') select.form.requestSubmit();
            else HTMLFormElement.prototype.submit.call(select.form);
          });
        });
        synchronize();
        const observer = new MutationObserver(() => {
          if (!footer.isConnected) {
            viewport.removeEventListener('change', synchronize);
            observer.disconnect();
          }
        });
        viewport.addEventListener('change', synchronize);
        observer.observe(document.documentElement, { childList: true, subtree: true });
        footer.setAttribute('data-footer-ready', '');
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
    else initialize(document);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
    document.addEventListener('shopify:block:select', (event) => {
      const column = event.target.closest('[data-footer-column]');
      if (column) column.open = true;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }
        this.currentScrollTop = this.headerBounds.bottom + 300;

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (theme.config.mqlSmall) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }

        this.currentScrollTop = scrollTop;
      }
      else {
        if (scrollTop > this.currentScrollTop) {
          requestAnimationFrame(this.reveal.bind(this));
        }
        else {
          requestAnimationFrame(this.hide.bind(this));

          if (scrollTop <= this.headerBounds.bottom) {
            requestAnimationFrame(this.reset.bind(this));
          }
        }
      }
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multicolumn"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (scope) => {
      scope.querySelectorAll('[data-zuuska-cards]').forEach((section) => {
        if (section.hasAttribute('data-cards-ready')) return;
        const track = section.querySelector('[data-cards-track]');
        const items = Array.from(section.querySelectorAll('[data-card-slide]'));
        const previous = section.querySelector('[data-cards-prev]');
        const next = section.querySelector('[data-cards-next]');
        const progress = section.querySelector('[data-cards-progress]');
        const mobile = window.matchMedia('(max-width: 749px)');
        const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const update = () => {
          const columns = Number(getComputedStyle(section).getPropertyValue('--zmc-mobile-columns'));
          section.toggleAttribute('data-two-mobile', mobile.matches && columns === 2);
          section.toggleAttribute('data-rtl', getComputedStyle(track).direction === 'rtl');
          if (!previous || !next || !items.length) return;
          const rtl = getComputedStyle(track).direction === 'rtl';
          const bounds = track.getBoundingClientRect();
          const first = items[0].getBoundingClientRect();
          const last = items[items.length - 1].getBoundingClientRect();
          const distance = rtl ? first.right - bounds.right : bounds.left - first.left;
          const remaining = rtl ? bounds.left - last.left : last.right - bounds.right;
          const total = Math.max(0, distance + remaining);
          previous.disabled = distance <= 2;
          next.disabled = remaining <= 2;
          if (progress) {
            const fraction = total > 0 ? Math.max(0, Math.min(1, distance / total)) : 1;
            progress.style.transform = 'scaleX(' + (0.2 + fraction * 0.8) + ')';
            progress.style.transformOrigin = rtl ? 'right' : 'left';
          }
        };
        const scroll = (step) => {
          if (!items.length || !mobile.matches) return;
          const rtl = getComputedStyle(track).direction === 'rtl';
          const gap = parseFloat(getComputedStyle(track).columnGap) || 16;
          const distance = items[0].getBoundingClientRect().width + gap;
          track.scrollBy({ left: distance * step * (rtl ? -1 : 1), behavior: motion.matches ? 'auto' : 'smooth' });
        };
        if (previous && next) {
          previous.addEventListener('click', () => scroll(-1));
          next.addEventListener('click', () => scroll(1));
        }
        let frame = 0;
        const schedule = () => {
          if (frame) return;
          frame = requestAnimationFrame(() => { frame = 0; update(); });
        };
        track.addEventListener('scroll', schedule, { passive: true });
        track.addEventListener('keydown', (event) => {
          if (event.target !== track || !section.hasAttribute('data-swipe-enabled') || !mobile.matches) return;
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          const rtl = getComputedStyle(track).direction === 'rtl';
          scroll((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
        });
        const observer = new ResizeObserver(schedule);
        observer.observe(track);
        const onUnload = (event) => {
          if (!event.target.contains(section)) return;
          observer.disconnect();
          mobile.removeEventListener('change', schedule);
          cancelAnimationFrame(frame);
          document.removeEventListener('shopify:section:unload', onUnload);
        };
        document.addEventListener('shopify:section:unload', onUnload);
        mobile.addEventListener('change', schedule);
        section.setAttribute('data-cards-ready', '');
        section.setAttribute('data-cards-enhanced', '');
        update();
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
    else initialize(document);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
    document.addEventListener('shopify:block:select', (event) => {
      const slide = event.target.closest('[data-card-slide]');
      const section = slide && slide.closest('[data-zuuska-cards]');
      if (!section || !section.hasAttribute('data-swipe-enabled') || !window.matchMedia('(max-width: 749px)').matches) return;
      const track = section.querySelector('[data-cards-track]');
      const rtl = getComputedStyle(track).direction === 'rtl';
      const bounds = track.getBoundingClientRect();
      const target = slide.getBoundingClientRect();
      track.scrollBy({ left: rtl ? target.right - bounds.right : target.left - bounds.left, behavior: 'auto' });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
